import { render } from "./KnowledgeChatPanel.vue?vue&type=template&id=7884081c&scoped=true"
import script from "./KnowledgeChatPanel.vue?vue&type=script&lang=js"
export * from "./KnowledgeChatPanel.vue?vue&type=script&lang=js"

import "./KnowledgeChatPanel.vue?vue&type=style&index=0&id=7884081c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7884081c"]])

export default __exports__